import React from 'react'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import EmptyView from '../../components/basic/EmptyView'
import _ from 'lodash'
import UserCouponDetail from '../../components/UserCouponDetail'

function UserCouponDetailScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { userCouponStore, navigation, route } = props
    const { couponId } = route.params
    const [isLoading, setIsLoading] = React.useState()
    const [isSuccessModalVisible, setIsSuccessModalVisible] = React.useState()

    React.useEffect(() => {
        const focus = navigation.addListener('focus', async () => {
            try {
                await userCouponStore.getUserCoupon(couponId)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        })
        return focus
    }, [navigation])

    React.useEffect(() => {
        const blur = navigation.addListener('blur', async () => {
            try {
                setIsSuccessModalVisible(false)
            }
            catch (e) {
                console.log(e)
            }
        })
        return blur
    }, [navigation])

    if (isLoading) {
        return <Loading />
    }

    const handleOnUseCouponPress = async () => {
        try {
            await userCouponStore.redeemUserCoupon(couponId)
            setIsSuccessModalVisible(true)
        }
        catch (e) {
            console.log(e)
        }

    }

    const handleOnSuccessModalClose = () => {
        setIsSuccessModalVisible(false)
        return navigation.navigate('Home')
    }

    if (!toJS(userCouponStore.coupon)) {
        return (<EmptyView
            t={t}
        />)
    }


    return (
        <UserCouponDetail
            t={t}
            buttonDisabled={toJS(userCouponStore.isLoading)}
            userCoupon={toJS(userCouponStore.coupon)}
            onUseCouponPress={() => handleOnUseCouponPress()}
            isSuccessModalVisible={isSuccessModalVisible}
            onSuccessModalClose={() => handleOnSuccessModalClose()}
        />
    )
}

export default inject('userCouponStore')(observer(UserCouponDetailScreen))